import { QuestionnaireGlobalModel, Page } from "../models/questionnaire.model";

export enum QuestionnaireActionTypes {
    SELECT_GROUP = "SELECT_GROUP",
    PHQ_SELECTED = "PHQ_SELECTED",
    UPDATE_PHQ = "UPDATE_PHQ",
    UPDATE_PHQLIST = "UPDATE_PHQLIST",
    PAGE_SELECTED = "PAGE_SELECTED",
    ADD_PAGE = "ADD_PAGE",
    UPDATE_PAGE = "UPDATE_PAGE",
    DELETE_PAGE = "DELETE_PAGE",
    UPDATE_SEARCH = "UPDATE_SEARCH",
    UPDATE_COLLAPSE = "UPDATE_COLLAPSE",
    REMOVE_GROUP = "REMOVE_GROUP",
    ADD_ITEM_TO_SECTION = "ADD_ITEM_TO_SECTION",
    NEW_SECTION = "NEW_SECTION",
    DELETE_SECTION = "DELETE_SECTION",
    UPDATE_SECTION = "UPDATE_SECTION",
    UPDATE_QUESTION = "UPDATE_QUESTION",
    DELETE_QUESTION = "DELETE_QUESTION",
    UPDATE_VERSION = "UPDATE_VERSION",
    UPDATE_VIEW_MODE = "UPDATE_VIEW_MODE",
    EXIT_VIEW_MODE = "EXIT_VIEW_MODE",
    RESTORE_PHQ = "RESTORE_PHQ",
    SET_PAGES = "SET_PAGES",
    SET_VERSIONS = "SET_VERSIONS",
    SET_SECTIONS = "SET_SECTIONS",
    SET_CONDITIONAL_MODE = "SET_CONDITIONAL_MODE",
}


export const questionnaireReducer = (state: QuestionnaireGlobalModel, action: { type: string; value: any; }) => {
    let phq = state.PhqSelected;

    switch (action.type) {
        case QuestionnaireActionTypes.SELECT_GROUP: return { ...state, SearchedText: '', GroupSelected: action.value };
        case QuestionnaireActionTypes.PHQ_SELECTED: return { ...state, PhqSelected: action.value };
        case QuestionnaireActionTypes.SET_CONDITIONAL_MODE:
            return { ...state, ConditionalLogicMode: action.value.ConditionalLogicMode, SelectedSection: action.value.Section };
        case QuestionnaireActionTypes.UPDATE_VERSION:
            return { ...state, PhqSelected: action.value };
        case QuestionnaireActionTypes.RESTORE_PHQ:
            const phqToRestore = action.value;
            const indCurrentPHQ = state.PhqList.findIndex(f => f.PHQID === phqToRestore.PHQID);
            const phqList = state.PhqList;
            phqList[indCurrentPHQ] = phqToRestore
            return { ...state, ViewMode: false, IsSnapShot: false, VersionIDViewing: 0, PhqList: phqList, PhqSelected: phqToRestore, SnapShotID: 0 };
        case QuestionnaireActionTypes.EXIT_VIEW_MODE:
            return { ...state, ViewMode: false, IsSnapShot: false, PhqSelected: JSON.parse(state.CurrentPHQ), SnapShotID: 0 };
        case QuestionnaireActionTypes.UPDATE_VIEW_MODE:
            return { ...state, PhqSelected: action.value.PhqSelected, IsSnapShot: action.value.IsSnapShot, SnapShotID: action.value.SnapshotID, ViewMode: action.value.ViewMode, VersionIDViewing: action.value.VersionID, CurrentPHQ: action.value.CurrentPHQ };
        case QuestionnaireActionTypes.UPDATE_PHQ:
            const updatedPHQ = action.value;
            updatedPHQ.Pages = phq.Pages; 
            return { ...state, PhqSelected: updatedPHQ };
        case QuestionnaireActionTypes.UPDATE_PHQLIST:
            return { ...state, PhqList: action.value };
        case QuestionnaireActionTypes.PAGE_SELECTED: return { ...state, PageSelected: action.value };
        case QuestionnaireActionTypes.ADD_PAGE:
            if (phq && phq.Pages && phq.Pages.length > 0) {
                phq.Pages.push(action.value);
            }
            else {
                phq.Pages = [action.value]
            }
            return { ...state, PhqSelected: phq };
        case QuestionnaireActionTypes.UPDATE_PAGE:
            // let phqToUpdate = state.PhqSelected;
            // if (phqToUpdate && phqToUpdate.Pages!.length > 0) {
            //     const pages = phqToUpdate.Pages
            //     const indexPageToUpdate = pages!.findIndex(f => f.PageID === action.value.PageID);
            //     pages![indexPageToUpdate] = action.value;
            // }
            return { ...state, PageSelected: action.value };
        case QuestionnaireActionTypes.UPDATE_COLLAPSE:
            const phgToCollapse = state.PhqSelected;
            if (phgToCollapse && phgToCollapse.Pages!.length > 0) {
                const pages = phgToCollapse.Pages
                const indexPageToUpdate = pages!.findIndex(f => f.PageID === action.value.PageID);
                const pageToUpdate = pages![indexPageToUpdate]
                pageToUpdate!.Collapsed = !pageToUpdate!.Collapsed
            }
            return { ...state, PhqSelected: phgToCollapse };
        case QuestionnaireActionTypes.DELETE_PAGE:
            const PHQtoDelete = state.PhqSelected;
            const indexPageToDelete = PHQtoDelete.Pages!.findIndex(f => f.PageID === action.value.PageID);
            PHQtoDelete.Pages!.splice(indexPageToDelete, 1);
            return { ...state, PhqSelected: PHQtoDelete };
        case QuestionnaireActionTypes.UPDATE_SEARCH: return { ...state, SearchedText: action.value };
        case QuestionnaireActionTypes.REMOVE_GROUP: return { ...state, GroupSelected: '' };
        case QuestionnaireActionTypes.ADD_ITEM_TO_SECTION:
            const pageToAdd = state.PageSelected as Page;

            if (pageToAdd.Sections && pageToAdd.Sections.length > 0) {
                const indexSectionToDelete = pageToAdd.Sections.findIndex(f => f.SectionID === action.value.sectionID);
                const sectToUp = pageToAdd.Sections[indexSectionToDelete];
                if (sectToUp) {
                    if (sectToUp.Questions && sectToUp.Questions.length > 0) {
                        sectToUp.Questions.push(action.value.sectionItem)
                    }
                    else {
                        sectToUp.Questions = [action.value.sectionItem]
                    }
                }
            }
            return { ...state, PageSelected: pageToAdd };
        case QuestionnaireActionTypes.NEW_SECTION:
            const statePageSelected = state.PageSelected;
            if(statePageSelected) {
                statePageSelected.Sections = [...(statePageSelected.Sections || []), action.value];
            }

            return { ...state, PageSelected: statePageSelected };
        case QuestionnaireActionTypes.DELETE_SECTION:
            const deleteStateSections = state.PageSelected!.Sections!;
            const indexSectionToDelete = deleteStateSections.findIndex(f => f.SectionID === action.value);
            deleteStateSections.splice(indexSectionToDelete, 1);
            return { ...state, Sections: deleteStateSections };
        case QuestionnaireActionTypes.UPDATE_SECTION:
            const pageSec = state.PageSelected;
            if (pageSec && pageSec.Sections) {
                const index = pageSec.Sections.findIndex(f => f.SectionID === action.value.sectionID);
                pageSec.Sections[index] = action.value.value;
            }
            return { ...state, PageSelected: pageSec };
        case QuestionnaireActionTypes.DELETE_QUESTION:
            const pageSelectToDeleteQuestion = state.PageSelected;
            const sectionItemState = pageSelectToDeleteQuestion.Sections;
            if (sectionItemState) {
                const indexItemSectionToDelete = sectionItemState.findIndex(f => f.SectionID === action.value.sectionId);
                const questions = sectionItemState[indexItemSectionToDelete].Questions;
                if (questions) {
                    const indexQuestionToDelete = questions.findIndex(f => f.QuestionID === action.value.question.QuestionID);
                    questions.splice(indexQuestionToDelete, 1)
                }
            }
            return { ...state, PageSelected: pageSelectToDeleteQuestion };
        case QuestionnaireActionTypes.UPDATE_QUESTION:
            const pageSelectToUpdateQuestion = state.PageSelected;
            return { ...state, PageSelected: pageSelectToUpdateQuestion };
        case QuestionnaireActionTypes.SET_PAGES:
            if(phq) {
                phq.Pages = action.value;
                return { ...state, PhqSelected: phq };
            }
            return {...state}

        case QuestionnaireActionTypes.SET_VERSIONS:
            phq.Versions = action.value;
            return { ...state, PhqSelected: phq };
        case QuestionnaireActionTypes.SET_SECTIONS:
            const selectedPage = state.PageSelected || new Page();
            selectedPage.Sections = action.value;
            return { ...state, PageSelected: selectedPage };
        case 'reset': return { SearchedText: '', GroupSelected: '' };
        case 'set': return action.value;

        default: throw new Error('Unexpected action');
    }
};